import { Card } from '../../ui';
import type { ServiceItem } from '../../../data';

export interface ServiceCardProps {
    service: ServiceItem;
    onClick?: () => void;
}

export function ServiceCard({ service, onClick }: ServiceCardProps) {
    return (
        <Card variant="outlined" hover onClick={onClick} className="text-center group">
            <div className="flex flex-col items-center">
                {/* Icon */}
                <div className="w-14 h-14 rounded-2xl bg-main-color/10 flex items-center justify-center mb-3 group-hover:bg-main-color group-hover:scale-110 transition-all duration-300">
                    <span className="text-main-color group-hover:text-white transition-colors">{service.icon}</span>
                </div>

                {/* Title */}
                <h3 className="font-font-s font-bold text-text-color text-base mb-2">{service.title}</h3>

                {/* Description */}
                <p className="font-font-s text-gray-600 text-sm leading-relaxed">{service.description}</p>
            </div>
        </Card>
    );
}
